<template>
  <div class="tab-pane fade" id="BetRecord" role="tabpanel"  aria-labelledby="home-tab">

                <div class="row ml-sm-3">  
                  <form class="form-inline" role="form">
                   
               
                    <div class="input-group input-daterange mr-sm-2"><label class="mr-sm-2">Date Range</label><datepicker format="yyyy-MM-dd"  value="2019-01-01" v-model="startdate" id="edstartdate" :bootstrap-styling="true" class="datewidth"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker format="yyyy-MM-dd"  value="2019-01-01" v-model="enddate" id="edenddate" :bootstrap-styling="true" class="datewidth"></datepicker> </div>


                     <div class="input-group input-daterange mr-sm-2"><label class="mr-sm-2">Game Type</label>
                    <select class="form-control" id="idgametype" v-model="edgametype"><option selected="true">All</option><option value="1">Baccarat</option><option value="2">Long Hu</option><option value="3">Sic Bo</option><option value="4">Roulette</option></select></div>


                    <div class="input-group mr-sm-2"><label class="mr-sm-2">Game Table</label>
                    <select class="form-control" id="cmbgametable">
                      <option>All</option></select></div>

                    <div class="input-group mr-sm-2"><label class="mr-sm-2">Agent</label>
                    <input class="form-control form-control-sm" v-model="edagentname" type="text" id="formGroupInputSmall" value=""></div>
                  </form>
                </div>

                <div class="row mt-3 ml-sm-3">
                   <form class="form-inline" role="form">

                   <div class="input-group mr-sm-2"><label class="mr-sm-2">Client</label>
                   <input class="form-control form-control-sm" type="text" id="idclientname" placeholder="" v-model="edclientname" value=""></div>

                     <div class="input-group mr-sm-2"><label class="mr-sm-2">Gameround ID</label>
                    <input class="form-control form-control-sm" type="text" id="formGroupInputSmall" v-model="edgameroundid" value=""></div>

                    <div class="input-group mr-sm-2"><label class="mr-sm-2">Bet Number</label>
                    <input class="form-control form-control-sm" type="text" id="formGroupInputSmall" v-model="edbetnumber" value=""></div>

                    <div class="input-group mr-sm-2"><label class="mr-sm-2">IP</label>
                    <input class="form-control form-control-sm" type="text" id="formGroupInputSmall" value="" v-model="edip"></div>
                  </form>
                  </div>
                  <div class="row mt-3 ml-sm-3">
                     <form class="form-inline" role="form">
                    <div class="input-group mr-sm-2"><label class="mr-sm-2">Game Status</label>
                      <select class="form-control" v-model="edgamestatus"><option value ="" selected>All</option><option value="WIN">WIN</option><option value="LOSE">LOSE</option></select>
                    </div>

                     <div class="input-group mr-sm-2"><label class="mr-sm-2">Client Platform Type</label>
                     <select class="form-control" v-model="edclientplatform"><option>All</option><option>Game 1</option><option>Game 2</option></select>
                    </div>


                     <button type="button" class="btn btn-primary mb-2" @click="getdatarep(edgametype,edclientname,startdate,enddate,edgamestatus,edagentname,edgameroundid,edbetnumber,edip)">Search</button>

                  </form>
                  
                </div>
                      <div class="ml-sm-3">
                 <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
           
                    <table id="mytable" class="table table-bordered table-striped table-hover table-dark" >

                      <thead>
                        <tr>
                          <th
                          scope="row"
                         
                          class="text-center"
                          style="vertical-align: middle;"
                          >Index</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Agent</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Client</th>
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Bet Number</th>
                          <th
                          scope="row"
                  
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Betting Time</th>
                          <th
                          scope="row"
       
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game Table</th>
                          <th
                          scope="row"
              
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game Type</th>
                          <th
                          scope="row" 
                          class="text-center"
                          style="vertical-align: middle;"
                          >Gameround ID</th>
                         
                  
                       
                        <th
                          scope="row"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game Result</th>

                          <th
                          scope="row"
              
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Play Type</th>

                          <th
                          scope="row"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>

                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Member Win/Loss</th>

                           <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>

                           <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Client Platform Type</th>

                         
                          <th
                          scope="row"
                          
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game Status</th>
                         
                        </tr>

                        
                      </thead>
                      <tbody>


                        <tr>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">
                          </td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                         
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>                     
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
              <div>

</div>
         

    </div>




</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters } from "vuex";
    import * as TYPES from "@/store/mutation-types";
    import api from '@/api'
    import moment from 'moment'

export default {
  name: "betrecord",
  components: {
    Datepicker
  },
  data: function() {
    return {
      dataTable:null,
      dtbet : [],
      DatePickerFormat: 'yyyy-MM-dd',
      arrtablegame : {
        tableid : ""
      },
      fields: [
          'index',
          { key : 'agent_name', label : 'Agent'},
          { key: 'userId', label: 'Client', sortable: true,  },
          { key: 'txId', label: 'Bet Number'},
          { key: 'betTime', label: 'Betting Time'},
          { key: 'tableId', label: 'Game Table'},
          { key: 'gameType', label: 'Game Type'},
          { key: 'roundId', label: 'Game Round ID'},
          { key: 'video', label: 'Card Set No'},
          { key: 'result', label: 'Game Result'},
          { key: 'category', label: 'Play Type'},
          { key: 'betAmount', label: 'Total Bet Amount'},
          { key: 'winLoss', label: 'Member Win/Loss'},
          { key: 'validBet', label: 'Valid Amount'},
          { key: 'dealerDomain', label: 'Client Platform Type'},
          { key: 'ip', label: 'IP'},
          { key: 'video', label: 'Video'},
          { key: 'status', label: 'Game Status'},
        ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterbetrecord: null,
      filterOn: [],
    }
  },
  
  computed: {
   ...mapGetters(["allBetRecords"]),
   getAllBetRecords(){
      return this.allBetRecords
    }
  },
  methods : {
     getreport(gametype,clientname){
        
        let par = {
           gametype : gametype,
           clientname : clientname
        }
        this.$store.dispatch(TYPES.FETCH_BETRECORDS, par)
            
     },
    doMath: function(index) {
      return index+1
    },
formatCurrency(value) {
          let val = (value/1).toFixed(2).replace(',', '.')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
moment: function (time) {
    return moment(time);
  },
    customFormatter(date) {
      return date.format('MMMM Do YYYY, h:mm:ss a');
    },
    getdatarep(gametype="",clientname="",startdate="",enddate="",edgamestatus="",edagentname="",edgameroundid="",edbetnumber="",edip=""){
       var awal = ''+$('#edstartdate').val()+' 00:00:00';
       var akhir = ''+$('#edenddate').val()+' 23:59:59';

     //  var awal = $('#edstartdate').val();
      // var akhir = $('#edenddate').val();

       //debugger;
       this.getreport(gametype,clientname)
       var search = '';

       if (gametype == 1){
         search='Baccarat'
       } else if (gametype == 2){
          search = 'DragonTiger'
       } else if (gametype == 3){
          search = 'Sicbo'
       } else if (gametype == 4){
         search = 'Roulette'
       } else {
         search = ""
       }


      var filter = new Object();

      if (search != ''){
         Object.assign(filter, {gameType: search});
      }
      if (edgamestatus != ''){
        Object.assign(filter, {status: edgamestatus});
      }
     /* if (edagentname != ''){
        Object.assign(filter, {status: edgamestatus});
      }*/

      if (edgameroundid != ''){
        Object.assign(filter, {roundId: edgameroundid});
      }

      if (edbetnumber != ''){
         Object.assign(filter, {txId: edbetnumber});
      }
      if (clientname != ''){
        Object.assign(filter, {userId: clientname});
      }
      if (edagentname != ''){
        Object.assign(filter, {agent_name: edagentname});
      }

      

       let myarr = this.getAllBetRecords

       var arr2 = myarr.filter(function(item) {
          for (var key in filter) {
            if (item[key] === undefined || item[key] != filter[key])
              return false;
            }
          return true;
      });

       var filter2 = new Object();

       if (awal != ''){
         Object.assign(filter2, {betTime: awal});
       }


       var arr = arr2.filter(function(item) {
          for (var key in filter2) {
            
          /*  var itemTime = new Date(item['betTime']).getDate();
            var newawal = new Date(awal).getDate();
            var newakhir =  new Date(akhir).getDate();*/
            var itemTime = new Date(item['betTime']);
          //  var newdate = ''+itemTime2.getFullYear()+'-'+itemTime2.getMonth()+'-'+itemTime2.getDate()+'';
          //  var itemTime = new Date(newdate)
            var newawal = new Date(awal);
            var newakhir =  new Date(akhir);
           // debugger;

           /* if (new Date(item['betTime']) < new Date(awal) || new Date(item['betTime']) > new Date(akhir))
              return false;
            } */
            if (itemTime < newawal || itemTime > newakhir) 

              return false;
            
            }
          return true;
      });

      // debugger;

      /* var arr =  myarr.filter(function(ar) {
            return ar.gameType == search;
        });*/



       this.dataTable.clear().draw()
       var totbetamount = 0;
       var totwinloss = 0;
       var totvalidamount = 0;

     //  for (var i = arr.length - 1; i >= 0; i--) {   
         for (var i = 0; i <= arr.length - 1;  i++) { 
          totbetamount = totbetamount + parseFloat(arr[i].betAmount);
          totwinloss = totwinloss + parseFloat(arr[i].winLoss);
          totvalidamount = totvalidamount + parseFloat(arr[i].validBet);

          this.dataTable.row.add([i+1,arr[i].agent_name,arr[i].userId,arr[i].txId,arr[i].betTime,
            arr[i].tableId,arr[i].gameType,arr[i].roundId,arr[i].result,arr[i].category,
            this.formatCurrency(arr[i].betAmount),this.formatCurrency(arr[i].winLoss),this.formatCurrency(arr[i].validBet),arr[i].dealerDomain,
            arr[i].status
          ]).draw(false)

      }

       this.dataTable.row.add([i+1,'TOTAL','','','',
            '','','','','',
            this.formatCurrency(totbetamount),this.formatCurrency(totwinloss),this.formatCurrency(totvalidamount),'',
            ''
          ]).draw(false)
      // var result =  mydatas.filter(mydata => mydata.gameType.toLowerCase().indexOf(search) > -1);

        
      /* var results=_.filter(this.getAllBetRecords,function(o){
          return o.gameType.toLowerCase().indexOf(search)>-1;
        });*/
      // debugger;
     //  let arr = this.getAllBetRecords;

   /*   this.dataTable.clear().draw()

      let endpoin = '';
      if (gametype == 1){
        endpoin = 'bacaratlog';
      } else if (gametype == 2){
        endpoin = 'longhulog';
      }
      else if (gametype == 3){
        endpoin = 'sicbolog';
      } else if (gametype == 4){
        endpoin = 'roulettelog';
      }

      api.get('client/'+endpoin+'?client_username='+clientname).then(({ data }) => {
        console.log("try to direct api");
        let arr = data.data;
          for (var i = arr.length - 1; i >= 0; i--) {
          console.log(arr[i])
          this.dataTable.row.add([i+1,'',arr[i].userId,arr[i].txId,arr[i].betTime,
            arr[i].tableId,arr[i].gameType,arr[i].roundId,'',arr[i].result,arr[i].category,
            arr[i].betAmount,arr[i].winLoss,arr[i].validBet,arr[i].dealerDomain,'','',
            arr[i].status
          ]).draw(false)
        }
        
      }) */    
    }
  },
  created(){
    // this.getreport("","");
     let par = {
           gametype : '',
           clientname : ''
        }
    this.$store.dispatch(TYPES.FETCH_BETRECORDS, par)
  },
   mounted(){
      this.dataTable = $('#mytable').DataTable({}); 

     /* let par = {
           gametype : '',
           clientname : ''
        }
      this.$store.dispatch(TYPES.FETCH_BETRECORDS, par)*/

      let myarr = this.allBetRecords;

     // debugger;

      var mytabarr = [];

      for (var i = myarr.length - 1; i >= 0; i--) {
        if (!mytabarr.includes(myarr[i].tableId)){
              mytabarr.push(myarr[i].tableId);
        //    $('#cmbgametable').append('<option value="'+myarr[i].tableId+'">'+myarr[i].tableId+'</option>');
        }
      }

      this.arrtablegame = mytabarr;

    //  debugger;

     // debugger;
    // this.arrtab = myarrtab;

      
   }
}

</script>